import { FC, Suspense, lazy } from 'react';
import getPreselectedValuesFromParams from 'app/components/timeSavers/assignMultipleTasksModal/utils/getPreselectedValuesFromParams';
import { ModalRouteProps } from 'context/ModalRouter';
import { useQueryClient } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { usePostsContainer } from 'components/posts/context';
import { useG2ReviewTrigger } from 'app/hooks/useG2ReviewTrigger';
import Skeleton from 'react-loading-skeleton';

const ChangePostsStatusWithPostsSelection = lazy(
  () =>
    import(
      'pages/posts/workflowOptions/changePostsStatus/ChangePostsStatusWithPostsSelection'
    ),
);
const ChangePostsStatusPreselectedPosts = lazy(
  () =>
    import(
      'pages/posts/workflowOptions/changePostsStatus/ChangePostsStatusPreselectedPosts'
    ),
);

type Props = ModalRouteProps;

const ChangePostsStatus: FC<Props> = (props) => {
  const queryClient = useQueryClient();
  const postsContainer = usePostsContainer();
  const { triggerG2Review } = useG2ReviewTrigger();

  const hasPreselectedPosts = (): boolean => {
    const preselectedValues = getPreselectedValuesFromParams(
      props.modalManager,
    );

    return preselectedValues.posts.length !== 0;
  };

  const handleSuccessRequest = () => {
    queryClient.invalidateQueries(queryKey.posts());
    postsContainer.clearSelectedPosts();
    triggerG2Review();
  };

  if (hasPreselectedPosts()) {
    return (
      <Suspense fallback={<Skeleton width="100%" height="100%" />}>
        <ChangePostsStatusPreselectedPosts
          onSuccessFormResponse={handleSuccessRequest}
          modalManager={props.modalManager}
        />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Skeleton width="100%" height="100%" />}>
      <ChangePostsStatusWithPostsSelection
        onSuccessFormResponse={handleSuccessRequest}
        modalManager={props.modalManager}
      />
    </Suspense>
  );
};

export default ChangePostsStatus;
